'use client'

import { useEffect, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

const OFFSET = 140

export default function ScrollToAnchorHandler() {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const hasScrolledRef = useRef(false)

	useEffect(() => {
		// Reset the scroll flag when pathname changes
		hasScrolledRef.current = false

		// Check if there's a hash in the URL
		const hash = window.location.hash

		if (hash && hash.startsWith('#spy_')) {
			// Extract the anchor ID from the hash (remove #spy_ prefix)
			const anchorId = hash.substring(5) // Remove '#spy_' prefix

			// Try to find the element with the spy_ prefixed ID
			let targetElement = document.getElementById(`spy_${anchorId}`)

			// If not found, try without the spy_ prefix (fallback)
			if (!targetElement) {
				targetElement = document.getElementById(anchorId)
			}

			if (targetElement && !hasScrolledRef.current) {
				// Mark that we've scrolled to prevent multiple scrolls
				hasScrolledRef.current = true

				// Scroll to the element with smooth behavior and offset
				setTimeout(() => {
					try {
						// Get the element's position relative to the viewport
						const elementRect = targetElement.getBoundingClientRect()
						const elementTop = elementRect.top + window.pageYOffset

						// Calculate scroll position with offset (e.g., 100px from top)
						const scrollPosition = elementTop - OFFSET

						// Scroll to the calculated position
						window.scrollTo({
							top: scrollPosition,
							behavior: 'smooth',
						})
					} catch (error) {
						console.warn('Failed to scroll to anchor:', error)
						// Fallback to the original scrollIntoView method
						targetElement.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						})
					}
				}, 150) // Slightly longer delay to ensure the page is fully rendered
			}
		}
	}, [pathname, searchParams]) // Re-run when pathname or search params change

	// This component doesn't render anything, it just handles the scroll logic
	return null
}
